<template>
	<div>
		<transition name="modal">
			<div v-if="show" class="modal-mask">
				<div class="modal-wrapper">
					<div class="modal-container">
						<div class="modal-header">
							{{ title }}
							<div style="margin-left: auto; margin-right: 0">
								<md-button @click="() => closeModal(false)" class="md-icon-button">
									<md-icon>close</md-icon>
								</md-button>
							</div>
						</div>
						<div class="modal-body text-center">
							<span v-html="content" />
							<main>
								<slot name="main"></slot>
							</main>
						</div>
						<div class="modal-footer">
							<footer>
								<slot name="footer"></slot>
							</footer>
							<div v-if="customButton">
								<md-button @click="closeModal(false)">{{ $t("cancel") }}</md-button>
								<md-button @click="closeModal(true)">OK</md-button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
export default {
	name: "modal",
	props: {
		show: Boolean,
		title: String,
		content: String,
		status: String,
		customButton: Boolean
	},
	methods: {
		closeModal: function (value) {
			this.$emit("close", value)
		}
	}
}
</script>

<style lang="scss">
.modal-enter {
	opacity: 0;
	font-size: 28px;
}

.modal-leave-active {
	opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
	-webkit-transform: scale(1.1);
	transform: scale(1.1);
}
</style>
